import { render } from "./MobileOnboardingView.vue?vue&type=template&id=3b20a5b2&scoped=true"
import script from "./MobileOnboardingView.vue?vue&type=script&lang=js"
export * from "./MobileOnboardingView.vue?vue&type=script&lang=js"

import "./MobileOnboardingView.vue?vue&type=style&index=0&id=3b20a5b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b20a5b2"]])

export default __exports__